import { useState, useRef, useEffect } from 'react';

interface CreateVisitDropdownsProps {
  onInstant: (medium: string) => void;
  onSchedule: (medium: string) => void;
  disabled?: boolean;
}

export function CreateVisitDropdowns({ onInstant, onSchedule, disabled }: CreateVisitDropdownsProps) {
  const [instantOpen, setInstantOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const instantRef = useRef<HTMLDivElement>(null);
  const scheduleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (instantRef.current && !instantRef.current.contains(e.target as Node)) setInstantOpen(false);
      if (scheduleRef.current && !scheduleRef.current.contains(e.target as Node)) setScheduleOpen(false);
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }}>
      <div className="dropdown" ref={instantRef}>
        <button
          className="btn btn--primary btn--sm"
          id="startVisitBtn"
          disabled={disabled}
          onClick={(e) => { e.stopPropagation(); setScheduleOpen(false); setInstantOpen(!instantOpen); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
          {' '}Instant Visit &#9662;
        </button>
        <div className={`dropdown-menu${instantOpen ? ' show' : ''}`}>
          <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setInstantOpen(false); onInstant('video'); }}>Video Visit</a>
          <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setInstantOpen(false); onInstant('phone'); }}>Phone Visit</a>
          <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setInstantOpen(false); onInstant('sms'); }}>SMS Text Visit</a>
        </div>
      </div>

      <div className="dropdown" ref={scheduleRef}>
        <button
          className="btn btn--outline btn--sm"
          id="scheduleVisitBtn"
          disabled={disabled}
          onClick={(e) => { e.stopPropagation(); setInstantOpen(false); setScheduleOpen(!scheduleOpen); }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
          {' '}Schedule Visit &#9662;
        </button>
        <div className={`dropdown-menu${scheduleOpen ? ' show' : ''}`}>
          <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setScheduleOpen(false); onSchedule('video'); }}>Video Visit</a>
          <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setScheduleOpen(false); onSchedule('phone'); }}>Phone Visit</a>
          <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setScheduleOpen(false); onSchedule('sms'); }}>SMS Text Visit</a>
        </div>
      </div>
    </div>
  );
}
